type CancelLinkProps = {
  isAppSubscription: boolean;
  isStripeMember: boolean;
  setIsCancelPlanOpen: (boolean) => void;
  initChurnkey: () => void;
};

const CancelLink = ({
  isAppSubscription,
  isStripeMember,
  setIsCancelPlanOpen,
  initChurnkey
}: CancelLinkProps) => {
  if (isAppSubscription || !isStripeMember) {
    return null;
  }
  return (
    <a
      className="flex justify-center mt-6 sm:my-0 cursor-pointer text-red-500"
      onClick={() =>
        isStripeMember ? initChurnkey() : setIsCancelPlanOpen(true)
      }
    >
      {'Cancel'}
    </a>
  );
};

export default CancelLink;
